module.exports = __webpack_public_path__ + "img/whatsApp.cf8e2abf.svg";